<template>
  <div class="path-map-editor">
    <!-- <div class="fs-16px">
      進階編輯 <b>({{ !isComplete }})</b>
    </div> -->
    <div class="journey-info row">
      <div class="col-12 col-md-6 order-1 order-lg-2">
        <div class="box trail-map" :class="{ 'scale-active': mapScale }">
          <img class="thumbnail d-md-none" :src="journeyData.picUrl" alt="路線縮圖">
          <div class="map-scale-cover-btn d-md-none" @click="mapScaleToggle">
            <div class="title fs-title-18">繪製路線</div>
          </div>
          <div class="path-map-group custom-z-index common-transition">
            <path-map-pro ref="map" @toggle-map-scale="mapScaleToggle" :hideScaleBtn="!isMobile" @reverse-map-route="journeyReverseBtnClicked"></path-map-pro>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 order-3 order-lg-3">
        <div class="box viewer custom-z-index common-transition" :class="{ 'scale-active': mapScale }">
          <MapControlPanel />
          <div class="bottom-btn-nav custom-z-index common-transition" :class="{ 'scale-active': mapScale }" v-if="isMobile">
            <b-button class="common-circle-btn dark justify-content-center" variant="dark" block @click="mapScaleToggle">
              <span>編輯完成</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PathMapPro from "@/components/MapEditor/PathMapPro.vue";
import MapControlPanel from "@/components/MapEditor/MapControlPanel.vue";
import {mapGetters} from "vuex";

export default {
  name: 'PathMapEditor',
  data() {
    return {
      mapObject: null,
      markerList: [],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      windowWidth: window.innerWidth,
      mapScale: false,

      startDate: '',
      durationDays: 1,
      restAry: [],
      startTimes: [],
      journeySplitIndexs: [],
      journeyPath: [],
      // 顯示在各區域的計算後資訊
      shownPathMilestones: [],
      loadedRoutes: [],
      loadedMilestones: [],
    };
  },
  props: {
    journeyData: {
      type: Object,
      required: true,
    }
  },
  components: {
    PathMapPro, MapControlPanel,
  },
  computed: {
    ...mapGetters('journey', ['isComplete']),

    isMobile() {
      return this.windowWidth < 768;
    },
    generatedJourney() {
      if(this.journeyData) {
        const genJ = {... this.journeyData};

        genJ.durationDays = this.journeySplitIndexs.length + 1;
        let cDate = moment(this.startDate);
        genJ.startDate = cDate.format('YYYY-MM-DD');
        cDate.add(genJ.durationDays - 1, 'days');
        genJ.endDate = cDate.format('YYYY-MM-DD');

        genJ.journeySplitIndexs.splice(0, genJ.journeySplitIndexs.length);
        for (let i=0;i<this.journeySplitIndexs.length;i++) {
          genJ.journeySplitIndexs.push(this.journeySplitIndexs[i]);
        }

        let climbRateIndex = 0;
        // genJ.climbRate = this.climbRate;

        const newJourney = [];

        let stepTime = moment(`${genJ.startDate} ${this.startTimes[0]}`);
        let dayCount = 0;
        for (let i=0;i<this.journeyPath.length;i++) {
          const newJ = {... this.journeyPath[i]};
          newJ.startTimestamp = stepTime.valueOf();
          newJ.startTime = stepTime.format('YYYY-MM-DD HH:mm');

          if (this.journeySplitIndexs.indexOf(i) !== -1) {
            climbRateIndex = climbRateIndex + 1
            dayCount = dayCount + 1;
            stepTime = moment(`${genJ.startDate} ${this.startTimes[dayCount]}`).add(dayCount, 'days');
          } else {
            if (newJ.type === 'route') {
              const detail = this.loadedRoutes.find((item) => {return item.serial === newJ.serial});
              newJ.detail = detail;
              const costMinutes = (newJ.direction === 0)?detail.consuming:detail.returnConsuming;
              const lastCostMinutes = costMinutes * genJ.climbRateArray[climbRateIndex];
              stepTime.add(lastCostMinutes, 'minutes');
            } else if (newJ.type === 'milestone') {
              const detail = this.loadedMilestones.find((item) => {return item.serial === newJ.serial});
              newJ.detail = detail;
              const costMinutes = this.restAry[i/2];
              stepTime.add(costMinutes, 'minutes');
            }
          }
          newJ.endTimestamp = stepTime.valueOf();
          newJ.endTime = stepTime.format('YYYY-MM-DD HH:mm');

          newJ.duration = (newJ.endTimestamp - newJ.startTimestamp) / (60 * 1000);

          newJourney.push(newJ);
        }
        genJ.journey = newJourney;

        return genJ;
      } else {
        return null
      }
    },
  },
  watch: {
    journeyData: {
      handler(newVal) {
        if (!newVal || !newVal.journey) return;
        this.buildPathMilestones(newVal.journey);

        this.startDate = this.journeyData.startDate;
        this.durationDays = this.journeyData.durationDays;

        this.journeySplitIndexs.splice(0, this.journeySplitIndexs.length);
        this.startTimes = [];
        this.startTimes.push(moment(this.journeyData.journey[0].endTimestamp).format('HH:mm'));
        for (let i=0;i<this.journeyData.journeySplitIndexs.length;i++) {
          this.journeySplitIndexs.push(this.journeyData.journeySplitIndexs[i]);
          this.startTimes.push(moment(this.journeyData.journey[this.journeySplitIndexs[i]].endTimestamp).format('HH:mm'));
        }

        this.restAry.splice(0, this.restAry.length);
        this.journeyPath = [];
        for (let i=0;i<this.journeyData.journey.length;i++) {
          const j = this.journeyData.journey[i];
          if (j.type === 'milestone') {
            this.saveLoadedMilestone(j.detail);
            if (this.journeySplitIndexs.indexOf(i) === -1) {
              // 計算休息時間
              const restMinutes = (j.endTimestamp - j.startTimestamp) / (60 * 1000);
              this.restAry.push(restMinutes);
            } else {
              this.restAry.push(0);
            }
          } else if (j.type === 'route') {
            this.saveLoadedRoute(j.detail);
          }

          this.journeyPath.push({... j});
        }
      },
      immediate: true, // 一進來就執行
      // deep: true        // 如果 journeyData 被更新也會觸發
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async mapScaleToggle() {
      this.mapScale = !this.mapScale;
      setTimeout(() => {
        this.$refs.map.fitToCurrentMilestones();
      }, 500);
    },
    saveLoadedMilestone(m) {
      const existM = this.loadedMilestones.find((item) => {
        return item.serial === m.serial;
      });
      if (!existM) {
        this.loadedMilestones.push(m);
      }
    },
    saveLoadedRoute(r) {
      const existR = this.loadedRoutes.find((item) => {
        return item.serial === r.serial;
      });
      if (!existR) {
        this.loadedRoutes.push(r);
      }
    },
    buildPathMilestones(journeyItems) {
      this.shownPathMilestones.splice(0, this.shownPathMilestones.length);

      for (const item of journeyItems) {
        if (item.type === 'milestone') {
          const found = this.shownPathMilestones.filter((m) => {
            return m.serial === item.detail.serial;
          });
          if (found.length === 0) {
            this.shownPathMilestones.push(item.detail);
          }
        }
      }
    },
    journeyReverseBtnClicked() {
      console.log('reverse')
      this.journeyReverse();
      this.$gtag.event('CustomClick', {
        event_label: "ReversePath",
      });
    },
    journeyReverse() {
      const journey = this.journeyPath;
      const newJourneySplitIndexs = [];
      for (let i=(this.journeySplitIndexs.length-1);i>=0;i--) {
        newJourneySplitIndexs.push((journey.length - 1) - this.journeySplitIndexs[i]);
      }
      // console.log(newJourneySplitIndexs);
      const newRestAry = [];
      for (let i = this.restAry.length - 1; i >= 0;i--) {
        newRestAry.push(this.restAry[i]);
      }

      const newJourneyData = [];
      for (let i=journey.length -1;i>=0;i--) {
        const temp = { ... journey[i]};
        if (temp.type === 'route') {
          temp.direction = 1 - temp.direction;
        }
        newJourneyData.push(temp);
      }

      this.journeySplitIndexs.splice(0);
      for (const s of newJourneySplitIndexs) {
        this.journeySplitIndexs.push(s);
      }
      this.journeyPath.splice(0);
      for (const s of newJourneyData) {
        this.journeyPath.push(s);
      }
      this.restAry.splice(0);
      for (const s of newRestAry) {
        this.restAry.push(s);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/basic";
.path-map-editor {
  position: relative;
  .map-scale-cover-btn {
    position: absolute;
    top: 0;
    left: 0;
    color: $color-white;
    background: $color-bk-tp-50;
    width: 100%;
    height: 100%;
    .title {
      border-radius: 100px;
      border: 4px solid $color-white;
      padding: .75rem 2.25rem;
    }
    @include smaller-than-medium {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .box.trail-map {
    overflow: hidden;
  }
  .bottom-btn-nav {
    position: fixed;
    bottom: -87px;
    left: 0;
    background: $color-white;
    width: 100%;
    box-shadow: 0px 2px 0px 0px #F3F3F3 inset;
    padding: 1rem 1.25rem 1rem;
    &.scale-active {
      bottom: 0;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/scss/basic";
.path-map-editor {
  .journey-info.row {
    .box {
      &.trail-map {
        @include smaller-than-medium {
          .path-map-group {
            height: calc(40% + 1rem);
          }
        }
      }
      &.viewer {
        @include smaller-than-medium {
          position: fixed;
          bottom: -60%;
          left: 0;
          background: $color-white;
          width: 100%;
          height: 60%;
          padding: .5rem .75rem 5rem 1rem;
          border-radius: 1rem 1rem 0 0;
          overflow: auto;
          &.scale-active {
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>

